module.exports = __webpack_public_path__ + "img/productIcon.5c750aef.png";